import { makeStyles } from '@material-ui/styles';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Typography, { TYPOGRAPHY_TITLE } from 'common/components/typography';
import event from '~helpers/mixpanel';
import Broadcast from './broadcast';
import HerculesOperationsPage from './operations';
import classNames from 'classnames';
import { pageType } from '~constants/pages';
import cookies from 'js-cookie';
import { cookieNames } from '~constants/storage';

const useStyles = makeStyles(() => ({
  dashboardWrapper: {
    padding: '40px 24px 74px',
    height: '100%',
  },
  row: {
    display: 'flex',
  },
  title: {
    margin: '0 0 32px',
    marginBottom: '32px !important',
  },
}));

const Dashboard = ({ landlord }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const partnerCookie = cookies.get(cookieNames.partner);

  useSelector(state => ({
    hasTotalOrders: state.auth.getIn(['properties', 'hasTotalOrders']),
    hasManualBookings: state.auth.getIn(['properties', 'hasManualBookings']),
  }));

  useEffect(() => {
    if (!cookies.get(cookieNames.partner)) {
      return;
    }
    event('Viewed Dashboard Page', { 'Current Page Type': pageType.dashboard });
    event('Viewed News Feed Page', { 'Current Page Type': pageType.dashboard });
  }, [partnerCookie]);

  return (
    <div className={classNames(classes.dashboardWrapper, 'dashboard-wrapper')}>
      <Typography
        textType={TYPOGRAPHY_TITLE}
        className={classes.title}
        fontSize={30}
        lineHeight={38}
      >
        {t('landlord.new_dashboard.title', {
          name: landlord?.firstName,
        })}
      </Typography>
      {/* DON'T NEED NOW, WILL SHOW IN THE FUTURE */}
      {/* <TopBanner t={t} /> */}
      <div className={classes.row}>
        <HerculesOperationsPage landlord={landlord} />
        <Broadcast landlord={landlord} t={t} />
      </div>
    </div>
  );
};

Dashboard.propTypes = {
  landlord: PropTypes.object,
};

export default Dashboard;
